import { useSyncExternalStore } from "react";

const watch = (query) => {
  const mql = typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query) : null;
  return {
    subscribe: (onChange) => {
      mql?.addEventListener("change", onChange);
      return () => mql?.removeEventListener("change", onChange);
    },
    get: () => !!mql?.matches,
  };
};

const phone = watch("(max-width: 767px)");
const belowDesktop = watch("(max-width: 1279px)");

/** Phone layout: below Tailwind `md` (768px). */
export function useIsPhone() {
  return useSyncExternalStore(phone.subscribe, phone.get, () => false);
}

/** Phone + tablet: below Tailwind `xl` (1280px), where module asides become drawers. */
export function useIsBelowDesktop() {
  return useSyncExternalStore(belowDesktop.subscribe, belowDesktop.get, () => false);
}
